/* Local wishlist only: no tracking, account data or external services. */
(() => {
  if (window.cardArenaInitialized) return;
  window.cardArenaInitialized = true;
  const key = 'cardarena:wishlist:v1';
  let fallback = [];
  const validURL = (value, image = false) => {
    try { const url = new URL(value, location.origin); return /^https?:$/.test(url.protocol) && (image || url.origin === location.origin) ? url.href : ''; } catch { return ''; }
  };
  const get = () => {
    try {
      const value = JSON.parse(localStorage.getItem(key) || '[]');
      return Array.isArray(value) ? value.filter(p => p && typeof p.id === 'string' && typeof p.title === 'string' && validURL(p.url)).slice(0,100) : [];
    } catch { return fallback; }
  };
  const save = items => {
    fallback = items;
    try { localStorage.setItem(key, JSON.stringify(items)); return true; } catch { return false; }
  };
  const sync = () => {
    const ids = new Set(get().map(p => p.id));
    document.querySelectorAll('[data-ca-save]').forEach(button => {
      const active = ids.has(button.dataset.id);
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', `${active ? 'Fjern' : 'Lagre'} ${button.dataset.title} ${active ? 'fra' : 'i'} ønskelisten`);
    });
  };
  const draw = () => {
    const target = document.querySelector('[data-ca-wishlist-list]');
    if (!target) return;
    target.replaceChildren();
    const items = get();
    if (!items.length) { const p = document.createElement('p'); p.className = 'ca-wish-empty'; p.textContent = 'Ingen favoritter ennå. Trykk på hjertet ved et produkt for å lagre det her.'; target.append(p); }
    items.forEach(item => {
      const row = document.createElement('div'); row.className = 'ca-wish-row';
      if (item.image && validURL(item.image, true)) { const img = document.createElement('img'); img.src = validURL(item.image, true); img.alt = ''; img.width = 65; img.height = 65; row.append(img); }
      const link = document.createElement('a'); link.href = validURL(item.url); link.textContent = item.title; row.append(link);
      const remove = document.createElement('button'); remove.type = 'button'; remove.dataset.caRemove = item.id; remove.textContent = 'Fjern'; remove.setAttribute('aria-label', `Fjern ${item.title}`); row.append(remove); target.append(row);
    });
  };
  document.addEventListener('click', event => {
    const element = event.target instanceof Element ? event.target : null;
    if (!element) return;
    const favorite = element.closest('[data-ca-save]');
    if (favorite) {
      let items = get(); const exists = items.some(p => p.id === favorite.dataset.id);
      if (exists) items = items.filter(p => p.id !== favorite.dataset.id);
      else { items.push({id: favorite.dataset.id, title: favorite.dataset.title, url: favorite.dataset.url, image: favorite.dataset.image}); items = items.slice(-100); }
      const stored = save(items); sync(); draw();
      const feedback = document.querySelector('.ca-save-feedback');
      if (feedback) feedback.textContent = stored ? (exists ? 'Fjernet fra ønskelisten.' : 'Lagret i ønskelisten.') : 'Lagret midlertidig. Nettleseren blokkerer varig lagring.';
    }
    if (element.closest('[data-ca-wishlist-open]')) { draw(); const dialog = document.getElementById('ca-wishlist'); if (dialog && !dialog.open) dialog.showModal(); }
    if (element.closest('[data-ca-wishlist-close]')) document.getElementById('ca-wishlist')?.close();
    const remove = element.closest('[data-ca-remove]');
    if (remove) { save(get().filter(p => p.id !== remove.dataset.caRemove)); sync(); draw(); document.querySelector('[data-ca-wishlist-close]')?.focus(); }
    document.querySelectorAll('.ca-nav-dropdown[open]').forEach(d => { if (!d.contains(element)) d.removeAttribute('open'); });
  });
  document.addEventListener('keydown', event => { if (event.key === 'Escape') document.querySelectorAll('.ca-nav-dropdown[open]').forEach(d => d.removeAttribute('open')); });
  document.addEventListener('shopify:section:load', sync);
  window.addEventListener('storage', () => { sync(); draw(); });
  window.addEventListener('pageshow', sync);
  sync();
})();
